
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-enter",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.622 22.4l2.489 2.489L24 16l-8.889-8.889L12.622 9.6l4.622 4.622H0v3.556h17.244z"}}),_c('path',{attrs:{"d":"M28.444 0H3.555A3.566 3.566 0 00-.001 3.556v7.111h3.556V3.556h24.889v24.889H3.555v-7.111H-.001v7.111c0 1.956 1.6 3.556 3.556 3.556h24.889c1.956 0 3.556-1.6 3.556-3.556V3.556C32 1.6 30.4 0 28.444 0z"}})])
          )
        }
      }
    